import * as Yup from 'yup'
import { valida_rut } from './Formatos';


export const validationSchemasPagoGestionDefenza = (fechaIngreso) => {
    let validation = {};

    validation.codMonedaIngreso = Yup.string().required('Este campo es obligatorio.');
    validation.fechaActualizacion = Yup.date()
        .required('Este campo es obligatorio.')
        .test("fechaPago", 'Fecha inválida.',
            (value) => {
                if (!fechaIngreso) return true;
                return value > new Date(fechaIngreso);
            }
        );
    validation.comentario = Yup.string().required('Este campo es obligatorio.');
    validation.destinatarioPago = validationDestinatario();

    return Yup.object().shape(validation);
}

export const validationSchemasCierreGestionDefenza = (limitePesadoBytes) => {
    let validation = {};

    validation.situacion = Yup.string().required('Seleccione una opción.');
    validation.comentario = Yup.string().required('Este campo es obligatorio.');
    validation.file = Yup
        .mixed()
        .test('fileSize', `Tamaño máximo del archivo ${limitePesadoBytes / 1000000}MB.`,
            (value) => {
                if (!value) return true;
                return value.size <= limitePesadoBytes;
            })

    return Yup.object().shape(validation);
}

const validationDestinatario = () => {
    let validation = {};

    validation.email = Yup.string().email('Email inválido.');
    /*validation.rut = Yup.string()
        .test('validate_rut', 'Rut invalido.',
            (value) => {
                if (!value) return true;
                return valida_rut(value);
            });*/

    return Yup.object().shape(validation);
}